module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "defaultNum": _vm.forAction.defaultNum,
      "deviceId": _vm.forAction.deviceId,
      "inputReadOnly": false,
      "defaultPackCount": _vm.amountPayload.packCount,
      "limitPackCount": false,
      "checkNum": _vm.forAction.checkNum
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_vm._v("此藥盒補藥數量")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f836d346","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RefillDrugFlow/ActionWrap.vue
// module id = 1555
// module chunks = 1